var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("select2", {
    ref: "select",
    attrs: {
      disabled: _vm.disabled,
      data: _vm.data,
      value: _vm.value,
      name: "definition-type",
      options: _vm.select2Options,
      "format-data": _vm.formatData,
    },
    on: { change: _vm.handleSelectChange },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }